var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7v62h50V7H13zm23 58H17V54h19v11zm23 0H40V54h19v11zm-3-17H17l3-3h39l-3 3zm0-8H17l3-3h39l-3 3zm0-8H17l3-3h39l-3 3zm0-8H17l3-3h39l-3 3zm0-8H17l3-3h39l-3 3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_down.a27c464c.svg";
export { SvgC1RollerShutterDown as ReactComponent };